export default {
  SET_PTO_FOR_GOOD_LIST: (state, data) => {
    state.ptoForGoodList = data
  },
  SET_PTO_FOR_GOOD_ONE: (state, data) => {
    state.ptoForGoodOne = data
  },
  SET_KNOWLEDGE_BASE_STATUSES_MINI: (state, data) => {
    state.ptoStatesMini = data
  },
}
